import { PromoAudience, PromoChannel, PromoDerivedStatus, PromoMessageStatus } from '../../types/promotions';

const STATUS_CLASS: Record<PromoDerivedStatus, string> = {
  ACTIVE: 'approved',
  SCHEDULED: 'update-requested',
  DISABLED: 'neutral',
  EXPIRED: 'rejected',
  FULL: 'warning',
};

const STATUS_LABEL: Record<PromoDerivedStatus, string> = {
  ACTIVE: 'Active', SCHEDULED: 'Scheduled', DISABLED: 'Disabled', EXPIRED: 'Expired', FULL: 'Full',
};

/** Derived code status (SCHEDULED · ACTIVE · DISABLED · EXPIRED · FULL); the text is always shown. */
export default function PromoStatusChip({ status }: { status: PromoDerivedStatus | string }) {
  const key = String(status).toUpperCase() as PromoDerivedStatus;
  return (
    <span className={`admin-badge ${STATUS_CLASS[key] ?? 'pending'}`} data-testid="promo-status">
      {STATUS_LABEL[key] ?? status}
    </span>
  );
}

export function AudienceChip({ audience }: { audience: PromoAudience | string }) {
  const invite = audience === 'INVITE_ONLY';
  return (
    <span className={`admin-badge ${invite ? 'admin' : 'garage-owner'}`} data-testid="promo-audience">
      {invite ? 'Invite-only' : 'Public'}
    </span>
  );
}

const MESSAGE_CLASS: Record<PromoMessageStatus, string> = {
  PENDING: 'pending', SENT: 'update-requested', DELIVERED: 'approved', READ: 'approved', FAILED: 'rejected', OPTED_OUT: 'neutral',
};

/** One delivery status per channel (A-5): "WhatsApp · DELIVERED". The provider error is the tooltip. */
export function MessageStatusChip({ channel, status, error }: {
  channel: PromoChannel | string;
  status: PromoMessageStatus | string;
  error?: string | null;
}) {
  const label = channel === 'WHATSAPP' ? 'WhatsApp' : channel === 'EMAIL' ? 'Email' : channel;
  return (
    <span
      className={`admin-badge ${MESSAGE_CLASS[status as PromoMessageStatus] ?? 'pending'}`}
      title={error ?? undefined}
      data-testid="promo-message-status"
    >
      {label} · {String(status).replace('_', ' ')}
    </span>
  );
}
